__turbopack_context__.v({
  "entriesByLetter": "entries-by-letter-module-scss-module__SFHELW__entriesByLetter",
  "entry": "entries-by-letter-module-scss-module__SFHELW__entry",
  "letter": "entries-by-letter-module-scss-module__SFHELW__letter",
  "lifetime": "entries-by-letter-module-scss-module__SFHELW__lifetime",
});
